import Vue from "vue";
import Vuex from "vuex";
import Auth from "./modules/Auth";
import Article from "./modules/Article";
import Challenges from "./modules/Challenges";
import Ad from "./modules/Ad";
import News from "./modules/News";
import Post from "./modules/Post";
import FeaturedUsers from "./modules/FeaturedUsers";
import SocialLink from "./modules/SocialLink";
import MusicRefernce from "./modules/MusicRefernce";
import MusicRoom from "./modules/MusicRoom";
import MusicVideos from "./modules/MusicVideos";
import MusicAudio from "./modules/MusicAudio";
import SocialCredits from "./modules/SocialCredits";
import Chat from "./modules/Chat";
import Users from "./modules/Users";
import Group from "./modules/Group";
import Search from "./modules/Search";
import Notification from "./modules/Notification";
import Subsciption from "./modules/Subsciption";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    genre: [
      "Alternative",
      "Afrobeat",
      "Anime",
      "Asian",
      "Blues",
      "Boom Bap",
      "Children’s",
      "Classical",
      "Conscious Rap",
      "Country",
      "Dance",
      "Electronic",
      "Folk",
      "Gospel",
      "Hip-Hop",
      "Holiday",
      "Indie",
      "Inspirational",
      "Instrumental",
      "Jazz",
      "K-Pop",
      "Latin",
      "Neo-Soul",
      "New-Age",
      "Metal",
      "Opera",
      "Pop",
      "R&B",
      "Rap",
      "Reggae",
      "Reggaeton",
      "Rock",
      "Singer-Songwriter",
      "Soundtrack",
      "Spoken Word",
      "Tex-Mex",
      "Trap",
      "Vocal",
      "World",
    ],
  },
  getters: {
    getGenre: (state) => state.genre,
  },
  modules: {
    Auth,
    Article,
    Challenges,
    Ad,
    News,
    Post,
    FeaturedUsers,
    SocialLink,
    MusicRefernce,
    MusicRoom,
    MusicVideos,
    MusicAudio,
    Chat,
    Users,
    Group,
    Notification,
    Subsciption,
    Search,
    SocialCredits,
  },
});
